import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

export const terminalsListBeforeEnter = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const { useStoreSettingsTerminals } = await import('@/entities/user-terminal')
  const { fetchTerminals } = useStoreSettingsTerminals()
  await fetchTerminals()
  next()
}
